import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '../../utilities/api';
import appearance from './appearance';
var StripeElements = function(props) {
    var clientSecret = props.clientSecret, children = props.children;
    return /*#__PURE__*/ React.createElement(Elements, {
        stripe: stripePromise,
        options: {
            appearance: appearance,
            clientSecret: clientSecret
        }
    }, children);
};
export default StripeElements;
